/**
 * External links shared by the public screens (landing, footer, auth).
 * Keeping the repository URL in one place stops the copies from drifting
 * apart when the repo moves.
 */
export const GITHUB_REPO_URL = 'https://github.com/lass-machen/meetropolis';
export const GITHUB_REPO_LABEL = 'lass-machen/meetropolis';
